<template>
  <div v-show="show">
    <FormKit
      :classes="{ outer: outerClasses }"
      :help="field.instructions"
      :label="field.name"
      :name="name"
      :options="options"
      :placeholder="field.placeholder"
      :validation="validation"
      :value="defaultValue"
      type="select"
    />
  </div>
</template>

<script setup lang="ts">
import { fieldName, fieldOptions, fieldOuterClasses, fieldSingleDefaultValue, fieldValidationArray, fieldVisible } from '~/assets/formie'

const props = defineProps({
  settings: { type: Object as PropType<Record<string, any>>, required: true },
  parentField: { type: Object as PropType<Record<string, any>>, required: false, default: undefined },
  field: { type: Object as PropType<Record<string, any>>, required: true },
})

const defaultValue = fieldSingleDefaultValue(props.field)
const name = fieldName(props.field, props.parentField)
const options = fieldOptions(props.field)
const outerClasses = fieldOuterClasses(props.settings, props.field)
const show = fieldVisible(props.field)
const validation = fieldValidationArray(props.field)
</script>
